export default __webpack_public_path__ + "static/media/classplus-logo.fd02c177.svg";